import { useState } from 'react';
import { METRIC_DEFINITIONS } from '../../constants/metricDefinitions';

interface MetricLabelProps {
  metric: string;
  children?: React.ReactNode;
  className?: string;
}

export function MetricLabel({ metric, children, className = '' }: MetricLabelProps) {
  const [show, setShow] = useState(false);
  const def = METRIC_DEFINITIONS[metric];

  if (!def) {
    return <span className={className}>{children || metric}</span>;
  }

  return (
    <span
      className={`relative inline-flex items-center gap-1 cursor-help ${className}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children || def.label}
      <span className="text-stone-700 text-sm leading-none select-none">{'\u24d8'}</span>

      {show && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 pointer-events-none">
          <span className="block bg-obsidian border border-gold/30 rounded-lg px-3 py-2 shadow-lg min-w-[220px] max-w-[300px]">
            <span className="block text-sm font-mono text-gold mb-1">{def.formula}</span>
            <span className="block text-sm text-ivory/80 leading-relaxed">{def.description}</span>
          </span>
          <span className="block w-0 h-0 mx-auto border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-gold/30" />
        </span>
      )}
    </span>
  );
}
